<template>
	<div class="legend-container" v-show="showLegend">
		<b-card no-body header-tag="header"><div slot="header" class="mb-0 d-flex"><div class="header">Layers</div><span class="ml-auto" style="margin-top:-2px;"><a class="close" href="#" @click.prevent="showLegend=!showLegend">&times;</a></span></div>
		  <ul class="list-group list-group-flush">
				<legend-item v-for="layer in layers.slice().reverse()" :layer="layer" :key="layer.id" :visible="layer.visible" />
		  </ul>
		</b-card>
	    <!-- Slot MUST remain in template or layers will not draw!! -->
		<slot/>
	</div>
</template>

<script>
import { Observable } from 'rxjs'
import { interval as intervalObs } from 'rxjs'
import { first as firstObs, map as mapObs, skipWhile, toPromise } from 'rxjs/operators'

import containerMixes from '../mixins/legend/legend-container.js'
import LegendItem from '../Legend/Item.vue'

const components = {
	LegendItem
}

const methods = {
	checkLayersContainer () {
      return intervalObs(100)
        .pipe(skipWhile(() => !this.$layersContainer))
        .pipe(skipWhile(() => !this.$layers))
        .pipe(firstObs())
        .pipe(mapObs(() => this))
        .toPromise(Promise)
    },
	setLayersVueContainer (vueLayersContainer) {
      this.$vueLayersContainer = vueLayersContainer
    },
}

export default {

  name: 'legend-container',
  components,
  methods,
  mixins: [containerMixes],
  created () {

  	this.legendMounted = false;

  	this.$vueLayersContainer = undefined;
      
    this.$on('layers-container-created', (e) => this.setLayersVueContainer(e))

    this._createPromise = Promise.resolve(this.checkLayersContainer())
	      .then(() => {
	      	this.legendMounted = true;
	        return this
		});

		Object.defineProperties(this, /** @lends module:map/view# */{
			$layersContainer: {
				enumerable: true,
				get: () => this.$vueLayersContainer
			},
			$layers: {
				enumerable: true,
				get: () => this.$vueLayersContainer.$layers
			},
			$view: {
				enumerable: true,
				get: () => this.$parent.$view
			}
		})

		this.$parent.$emit('legend-container-created', this);
  },
  mounted () {
  	this.$layersContainer.$on('layer-added', (e) => this.addLayers(e));
  },
  data () {
    return {
    	layers: [],
    	showLegend: true
    }
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Base/LegendContainer.vue